import React, { memo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { VehicleType, vehicleNamesMap } from 'src/constants/vehicle'
import { colors } from 'src/theme'
import tw from 'twin.macro'

interface Props {
  type: VehicleType | null
}

const VehicleTypeChipComponent = ({ type }: Props) => {
  if (!type) {
    return <span>-</span>
  }

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`py-1 rounded-[10px]`}>
        <Chip
          className={tw`bg-[rgba(218, 217, 224, 1)]`}
          textColor={colors.SHADES_GREY_500}
          text={vehicleNamesMap[type] || type}
        />
      </div>
    </div>
  )
}

export const VehicleTypeChip = memo(VehicleTypeChipComponent)
